export enum UserType {
    Admin = 1,
    Buyer = 2,
    Photographer = 3,
    Editor = 4,
    ChiefEditor = 5,
}

export enum ImageStatusEnum {
    WaitingForApproval = 1,
    Active = 2,
    Inactive = 3,
    Deleted = 4,
    Rejected = 5
}

export enum ZohoSyncRequestType {
    Bills = 1
}
